import { connect } from 'react-redux';
import BusinessAmbassadorsList from "./BusinessAmbassadorsList";
import {getTranslation} from "../../../reducers/common/localization";
import {MODAL_REMOVE_BUSINESS_AMBASSADOR, showModal} from "../../../reducers/common/activeModal";
import {
    fetchGetBusinessAmbassadors,
    getBusinessAmbassadorsData, loadingBusinessAmbassadors
} from "../../../reducers/businessAmbassador/businessAmbassadors";

const mapStateToProps = state => {
    return {
        loading: loadingBusinessAmbassadors(state),
        data: getBusinessAmbassadorsData(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetBusinessAmbassadors())
        },
        onRemoveButtonClick: () => {
            dispatch(showModal({modalKey: MODAL_REMOVE_BUSINESS_AMBASSADOR}));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessAmbassadorsList);


// WEBPACK FOOTER //
// ./src/components/businessAmbassadorsManagement/businessAmbassadorsList/BusinessAmbassadorsList.container.js